import React, { useEffect, useState } from "react";
import { Fragment } from "react";
import { api } from "../../_services/api.service";
import { Row, Col, Card, CardBody, CustomInput, Button } from "reactstrap";
import Loader from "react-loaders";
import PageTitle from "../../Layout/AppMain/PageTitle";
import { toast } from "react-toastify";
import { customFormatter } from "../../utils/tabulator";
import { ReactTabulator } from "react-tabulator";
import { userService } from "../../_services/user.service";
import download from "downloadjs";

const DecisionTemplateList = (props) => {
  const currentUser = userService.getLoggedInUser();
  let partnerId = parseInt(props.match.params.partnerId);
  let [partnerScenarios, setPartnerScenarios] = useState([]);
  let [isLoading, setIsLoading] = useState(false);
  let [isLoadingReport, setIsLoadingReport] = useState(false);
  const [partner, setPartner] = useState(null);
  const [columns, setColumns] = useState([]);

  const successToastOpts = {
    autoClose: 3000,
    type: toast.TYPE.SUCCESS,
    hideProgressBar: false,
  };

  useEffect(() => {
    if (partnerId > 0) {
      loadData(partnerId);
    }
  }, []);

  useEffect(() => {
    if (partner != undefined && partner != null) {
      setColumns([
        {
          rowHandle: true,
          formatter: "handle",
          headerSort: false,
          width: 50,
          frozen: false,
        },
        {
          title: "Template Name",
          field: "partnerScenarioName",
          width: 350,
          frozen: false,
          // headerFilter: "input",
          formatter: customFormatter(({ rowData, cellValue }) => {
            return (
              <a
                href="#"
                onClick={(e) => {
                  e.preventDefault();
                  goToResults(rowData.partnerScenarioID);
                }}
              >
                {cellValue}
              </a>
            );
          }),
        },
        {
          field: "templateCategory",
          title: "Category",
          width: 200,
        },
        {
          field: "description",
          title: "Description",
          width: 200,
        },
        {
          field: "costName",
          title: "Cost Description",
          width: 200,
        },
        {
          field: "numPartnerObjectives",
          title: "# Criteria",
          width: 150,
        },
        {
          field: "numPartnerMetrics",
          title: "# Data Items",
          width: 200,
        },
        {
          field: "numPartnerAlternatives",
          title: "# Alternatives",
          width: 200,
        },
        {
          field: "numScenarios",
          title: `# ${partner?.decisionName ?? "Decision"}`,
          width: 150,
        },
        {
          field: "parentName",
          title: "Parent",
          width: 150,
        },
        {
          field: "publicScenario",
          title: "Public",
          width: 150,
          // formatter: (cell, formatterParams, onRendered) => {
          //   onRendered(() => {
          //     let rowData = cell.getData();
          //     ReactDOM.render(
          //       <CustomInput
          //         readOnly={true}
          //         type="checkbox"
          //         id={`publicScenario-${rowData.scenarioID}`}
          //         checked={rowData.publicScenario}
          //       />,
          //       cell.getElement()
          //     );
          //   });
          // },
          formatter: customFormatter(({ rowData, cellValue }) => {
            return (
              <CustomInput
                readOnly={true}
                type="checkbox"
                id={`publicScenario-${rowData.scenarioID}`}
                checked={rowData.publicScenario}
              />
            );
          }),
        },
        {
          field: "ahpOnly",
          title: "AHP Only",
          width: 150,
          formatter: customFormatter(({ rowData, cellValue }) => {
            return (
              <CustomInput
                readOnly={true}
                type="checkbox"
                id={`publicScenarioAhp-${rowData.scenarioID}`}
                checked={rowData.ahpOnly}
              />
            );
          }),
        },
        {
          field: "usePhases",
          title: "Use Phases",
          width: 150,
          formatter: customFormatter(({ rowData, cellValue }) => {
            return (
              <CustomInput
                readOnly={true}
                type="checkbox"
                id={`publicScenarioPhase-${rowData.scenarioID}`}
                checked={rowData.usePhases}
              />
            );
          }),
        },
        {
          field: "isSurvey",
          title: "Survey",
          width: 150,
          formatter: customFormatter(({ rowData, cellValue }) => {
            return (
              <CustomInput
                readOnly={true}
                type="checkbox"
                id={`usSUrvey-${rowData.scenarioID}`}
                checked={rowData.isSurvey}
              />
            );
          }),
        },
        {
          field: "inactive",
          title: "Inactive",
          width: 150,
          formatter: customFormatter(({ rowData, cellValue }) => {
            return (
              <CustomInput
                readOnly={true}
                type="checkbox"
                id={`inactive-${rowData.scenarioID}`}
                checked={rowData.inactive}
              />
            );
          }),
        },
      ]);
    }
  }, [partner]);

  const loadData = (pid) => {
    setIsLoading(true);
    api.getPartnerById(partnerId).then((p) => {
      setPartner(p);
    });
    api.getPartnerScenariosByPartnerId(pid).then((data) => {
      setPartnerScenarios(data);
      setIsLoading(false);
    });
  };

  const createNewTemplate = () => {
    props.history.push({
      pathname: `/decisiontemplate/${partnerId}/-1`,
    });
  };

  const goToResults = (partnerScenarioID) => {
    props.history.push({
      pathname: `/decisiontemplateresults/${partnerId}/${partnerScenarioID}`,
    });
  };

  const defaultSorted = [
    {
      dataField: "partnerScenarioName",
      order: "asc",
    },
  ];

  const options = {
    sizePerPageList: [
      {
        text: "50",
        value: 50,
      },
    ],
    hideSizePerPage: true,
    hidePageListOnlyOnePage: true,
  };

  const updatePartnerScenarios = async (list) => {
    let tasks = list
      .filter((x) => x.isDirty)
      .map((x) => async () => {
        return await api.updatePartnerScenario(currentUser.userId, x);
      });
    await Promise.all(tasks.map((t) => t()));
  };

  const getTemplateReport = () => {
    setIsLoadingReport(true);

    api.getScenarioReportQueryParam(currentUser.userId).then((guid) => {
      api.getTemplateOverviewReport(currentUser.userId, partnerId, guid).then(
        (blob) => {
          setIsLoadingReport(false);
          download(blob, "TemplateOverviewReport.pdf");
        },
        (err) => setIsLoadingReport(false)
      );
    });
  };

  return (
    <Fragment>
      <PageTitle
        icon="far fa-list-alt"
        heading={`${partner?.decisionName ?? "Decision"} Templates`}
      />

      <Row style={{ marginTop: "30px" }}>
        <Col md="12">
          <Card className="main-card mb-3">
            <CardBody>
              <Row>
                <div className="mb-3">
                  Below is a list of decision templates setup for your
                  organization. A decision template defines criteria and/or
                  alternatives as well as other settings that are then made
                  available to your users. A template can also help users focus
                  decisions on core things that the organization feels are
                  important to ensure consistency around how key decisions are
                  made. Lastly, templates allow you to gather all the data about
                  the decisions that were made using the template to gain
                  insights into how your decision makers are doing.
                </div>
                {isLoading && <Loader style={{}} type="ball-pulse" active />}
                {!isLoading && columns.length > 0 && (
                  <ReactTabulator
                    // onRef={(r) => (tabulatorRef.current = r.current)}
                    columns={columns}
                    data={partnerScenarios}
                    options={{
                      movableRows: true,
                      pagination: "local",
                      paginationSize: 30,
                      paginationSizeSelector: [
                        5, 10, 20, 30, 50, 100, 200, 300,
                      ],
                      layout:
                        columns.length > 6 ? "fitDataStretch" : "fitColumns",
                      cssClass: "table-borderless",
                    }}
                    style={{ width: "100%" }}
                    events={{
                      rowMoved: function (row) {
                        let list = row.getTable().getData();
                        list = list.map((l, idx) => {
                          if (l.orderID != idx + 1) {
                            l.orderID = idx + 1;
                            l.isDirty = true;
                          }
                          return l;
                        });

                        setPartnerScenarios(list);
                        updatePartnerScenarios(list);
                      },
                    }}
                  />
                )}
                <Row>
                  <Col>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        gap: "20px",
                        alignItems: "center",
                        marginTop: "20px",
                      }}
                    >
                      <Button color="primary" onClick={createNewTemplate}>
                        {`Add ${partner?.decisionName ?? "Decision"} Template`}
                      </Button>
                      <Button
                        color="primary"
                        onClick={getTemplateReport}
                        disabled={isLoadingReport}
                      >
                        Template Overview Report
                      </Button>
                    </div>
                  </Col>
                </Row>
              </Row>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </Fragment>
  );
};

export default DecisionTemplateList;
